import { ContractTerm, ContractTermCost, ContractTermCostTierId } from 'pricing/types';

export const getTermInitialCost = (contractTerm: ContractTerm): number | undefined => {
  return contractTerm.costs?.find(
    (term: ContractTermCost) =>
      term.breederContractTermCostTierId === ContractTermCostTierId.Initial,
  )?.cost;
};

export const getTermInitialPrice = (contractTerm: ContractTerm): number | undefined => {
  return contractTerm.costs?.find(
    (term: ContractTermCost) =>
      term.breederContractTermCostTierId === ContractTermCostTierId.Initial,
  )?.price;
};

export const getTermMiddleCost = (contractTerm: ContractTerm): number | undefined => {
  return contractTerm.costs?.find(
    (term: ContractTermCost) =>
      term.breederContractTermCostTierId === ContractTermCostTierId.Decreased,
  )?.cost;
};

export const getTermMiddlePrice = (contractTerm: ContractTerm): number | undefined => {
  return contractTerm.costs?.find(
    (term: ContractTermCost) =>
      term.breederContractTermCostTierId === ContractTermCostTierId.Decreased,
  )?.price;
};

export const getTermFinalCost = (contractTerm: ContractTerm): number | undefined => {
  return contractTerm.costs?.find(
    (term: ContractTermCost) =>
      term.breederContractTermCostTierId === ContractTermCostTierId.Final,
  )?.cost;
};

export const getTermFinalPrice = (contractTerm: ContractTerm): number | undefined => {
  return contractTerm.costs?.find(
    (term: ContractTermCost) =>
      term.breederContractTermCostTierId === ContractTermCostTierId.Final,
  )?.price;
};
